import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getTransactionDetailsLoadingState = (
  state: RootState,
): RootState['transactions']['transactionDetails']['loading'] => state.transactions.transactionDetails.loading

export const transactionDetailsLoading = createSelector(
  getTransactionDetailsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getTransactionDetailsData = (state: RootState): RootState['transactions']['transactionDetails']['data'] =>
  state.transactions.transactionDetails.data
